import { FunctionComponent, useState } from "react";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { ActionsContext, LocalGameActions } from "./ActionsContext";
import GameRoom from "./GameRoom";
import { GameMode, Player } from "./Types";
import { default as MatchSettingsMenu, MatchPointValue } from "./MatchSettingsMenu";

const LocalGameRoom: FunctionComponent = () => {
  const settings = useAppSelector((state) => state.settings);
  const dispatch = useAppDispatch();

  const [matchPointsValue, setMatchPointsValue] = useState<MatchPointValue>(1);
  const [enableDoubling, setEnableDoubling]     = useState(false);

  return (
    <ActionsContext.Provider value={new LocalGameActions(dispatch, settings.gameMode)}>
      {settings.showMatchSetupScreen ? (
        <MatchSettingsMenu
          matchPointsValue={matchPointsValue}
          enableDoubling={enableDoubling}
          onMatchPointsChanged={setMatchPointsValue}
          onEnableDoublingChanged={setEnableDoubling}
          roomCode={null}
        />
      ) : (
        <GameRoom playerPerspective={Player.One} />
      )}
    </ActionsContext.Provider>
  );
};

export default LocalGameRoom;
